import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d1f9b55")

_pushScopeId("data-v-1d1f9b55")
const _hoisted_1 = { class: "root" }
const _hoisted_2 = {
  key: 0,
  class: "menu"
}
const _hoisted_3 = {
  key: 1,
  class: "view"
}
const _hoisted_4 = {
  key: 0,
  class: "header"
}
const _hoisted_5 = { class: "contents" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AdminMenu = _resolveComponent("AdminMenu")
  const _component_AdminHeader = _resolveComponent("AdminHeader")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isTop)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_AdminMenu)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isTop || _ctx.data.isLoaded)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          (_ctx.viewTitle !== undefined)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_AdminHeader, { title: _ctx.viewTitle }, null, 8, ["title"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})